import React from 'react';
import Cookies from 'js-cookie';
import moment from 'moment';
import ConfigUtility from 'Core/ConfigUtility';
import { GeneralNotificationHandler } from './GeneralNotificationHandler';
import { Modal, Button, Col } from 'antd';
import { LeftAlignRow } from 'components/Styled/Layout.Styled';
import AuthContext from 'Context/AuthContext';
import { AuthUser } from 'Core/models/AuthUser';

export interface Props {
  children?: React.ReactNode;
}

export interface State {
  notice?: string;
  showModal: boolean;
  currentUser?: AuthUser;
}

export default class GeneralNotificationView extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;
  handler: GeneralNotificationHandler;
  config = ConfigUtility.getSync();

  constructor(props: Props) {
    super(props);

    this.state = {
      showModal: false,
      notice: '',
    };
    this.handler = new GeneralNotificationHandler();
  }

  showNotification() {
    this.handler
      .GetNotification()
      .then(response => {
        const messageOfTheDayCookie = this.config!.ShowMessageOfTheDayCookieName + '_' + this.context.data?.id;
        if (response) {
          if (!Cookies.get(messageOfTheDayCookie) && this.context.data?.id) {
            this.setState({ notice: response, showModal: true });
            Cookies.set(messageOfTheDayCookie, moment.toString(), { secure: true });
          } else {
            if (moment(Cookies.get(messageOfTheDayCookie)).isBefore()) {
              this.setState({ notice: response, showModal: true });
              Cookies.set(messageOfTheDayCookie, moment.toString(), { secure: true });
            }
          }
        }
      })
      .catch(error => console.log('Error: ', error));
  }



  componentDidUpdate(prevProps: Props, prevState: State) {

    if (this.context.data?.id !== prevState.currentUser?.id) {
      if (this.context.data?.id) {

        this.setState({ currentUser: this.context.data });

        if (this.state.currentUser) {
          setTimeout(() => {
            this.showNotification();
          }, 1500);
        }

      } else {
        Cookies.remove(this.config!.ShowMessageOfTheDayCookieName + '_' + this.context.data?.id);
      }
    }
  }

  handleClose = () => {
    this.setState({ showModal: false });
  };

  render() {
    return (
      <>
        {this.props.children}
        <Modal
          key="generalNotice"
          visible={this.state.showModal}
          footer={<Button onClick={this.handleClose}>Close</Button>}
          closable={true}
          title="Message of the Day">
          <LeftAlignRow>
            <Col>
              <p>{this.state.notice}</p>
            </Col>
          </LeftAlignRow>
        </Modal>
      </>
    );
  }
}
